module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-ORANGE-CREAM.1bd1af4.1bd1af4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-ORANGE-CREAM.1bd1af4.gif
// module id = 61va
// module chunks = 0